import config from '../../../config';

const baseUrl = `${config.apiUrl()}/BackOffice/FleetEntities`;

export default {
  editFleetEntities: (fleetEntityId): string => `${baseUrl}/${fleetEntityId}`,
  deleteFleetEntity: (fleetEntityId): string => `${baseUrl}/${fleetEntityId}`,
  addFleetEntitiesUrl: (): string => `${baseUrl}`,
};
